import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle, faPlus } from '@fortawesome/pro-solid-svg-icons'
import { useAppDispatch } from 'store/hooks'
import { slices } from 'store/slices'
import List from './list'
import { Wrapper, Header, Alert } from './styled'

const Sections = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const translationPrefix = 'administration.blocks.type.questionBankV2.sections'

  return (
    <Wrapper>
      <Header>
        <Alert>
          <FontAwesomeIcon icon={faInfoCircle} />
          {t(`${translationPrefix}.alert`)}
        </Alert>
        <Button onClick={() => dispatch(slices.questionBank.addEmptySection())}>
          <FontAwesomeIcon icon={faPlus} />
          {t(`${translationPrefix}.addSection`)}
        </Button>
      </Header>
      <List />
    </Wrapper>
  )
}

export default Sections
